import React from "react";
import { cn } from "../../utils/cn";

export default function PageHeader({ title, subtitle, actions, className }) {
  if (!title && !subtitle && !actions) return null;

  return (
    <div
      className={cn(
        "mb-7 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between",
        className
      )}
    >
      <div>
        {title && (
          <h1 className="text-[28px] leading-tight font-semibold text-foreground tracking-[-0.045em] sm:text-[32px]">
            {title}
          </h1>
        )}
        {subtitle && (
          <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{subtitle}</p>
        )}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}
